<script>
   
</script>


<main>
    <div class='badges'>
        <img src="/images/cyclist.jpg" alt=''/>
        <img src="/images/emblem.jpg" alt=''/>
        <img src="/images/walkers.jpg" alt=''/>
    </div>
    <p>
        Phone: 01341 423405    Mobile : 07786 904895
    </p>
    
    <p>
        Mawddach Cottages, Maesygarnedd Farm, Llanelltyd, Dolgellau, Gwynedd LL40 2TA
    </p>
    
</main>


<style>
.badges{
    display:flex;
    flex-direction: row;
    justify-content: space-around;
}
.badges img{
    height: 100px;
}
p{
    text-align: center;
}
main{
    margin: auto;
    margin-top: 56px;
    
}


</style>